import React from "react";

export function StepHeader({
  eyebrow,
  icon,
  title,
  description,
  titleId,
  centered = false,
  compact = false,
}) {
  return (
    <header
      className={`kyc-step-header ${centered ? "text-center" : ""}`.trim()}
    >
      {eyebrow && (
        <span className="inline-flex items-center gap-2 rounded-full bg-teal-50 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-teal-800">
          {icon}
          {eyebrow}
        </span>
      )}
      <h1
        id={titleId}
        className={
          compact
            ? "mt-2 text-xl font-semibold leading-tight tracking-[-0.025em] text-slate-950 sm:text-2xl"
            : "mt-4 text-[1.75rem] font-semibold leading-tight tracking-[-0.035em] text-slate-950 sm:text-[2rem]"
        }
      >
        {title}
      </h1>
      {description && (
        <p
          className={`${compact ? "mt-1.5 leading-5" : "mt-3 leading-6 sm:leading-7"} max-w-xl text-sm text-slate-600 sm:text-[15px] ${
            centered ? "mx-auto" : ""
          }`}
        >
          {description}
        </p>
      )}
    </header>
  );
}
